import apiService from '../api/api.service';
import {CampaignType} from '../campaigns/campaigns.types';
import {DSPType} from './dsp.types';
import apiV2Service from '../api/api-v2.service';
import {JobExecutionParams} from '../jobs/jobs.types';
import waitForJob from '../jobs/utils/waitForJob';

const dspApiBasePath = 'DspApi';
const dspBasePath = 'Dsp';

async function pullPlacementsFromDSP({
  campaignId,
  campaignVersionId,
  campaignIntegrationIds,
  jobTitle = 'Synchronize DSP Placements',
}: {
  campaignId: number;
  campaignIntegrationIds: number[];
  campaignVersionId?: number;
  jobTitle?: string;
}) {
  const url = `${dspApiBasePath}/PullPlacementsFromDSP`;

  const {data: syncJobs} = await apiService.executePostRequest<JobExecutionParams[]>(url, {
    campaignId,
    campaignVersionId,
    campaignIntegrationIds,
  });

  return await Promise.all(
    syncJobs
      .filter((job) => !!job.executionId)
      .map((job) =>
        waitForJob({
          jobId: job.executionId,
          jobName: jobTitle,
        }),
      ),
  );
}

async function  getAll(params: {campaignType?: CampaignType}) {
  const url = `${dspBasePath}/GetAll`;

  const {data} = await apiV2Service.executeGetRequest<{dsps: DSPType[]}>(url, params);

  return data.dsps.filter((dsp) => !dsp.isDeprecated);
}

async function getParametersForPublisher(params: {campaignId: number; publisherId: string}) {
  const {data} = await apiV2Service.executeGetRequest<number[]>(
    `${dspBasePath}/GetParametersForPublisher/${params.campaignId}`,
    {
      publisherId: params.publisherId,
    },
  );

  return data;
}

export const dspApi = {
  pullPlacementsFromDSP,
  getAll,
  getParametersForPublisher,
};
